import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { API_BASE_URL } from '../config/api.config';
import {
  BusinessSettingsAdmin,
  StripeWebhookEndpointsResponse,
  TenantModules,
  UpdateBusinessSettingsPayload
} from '../models/business-config.model';

@Injectable({ providedIn: 'root' })
export class BusinessConfigService {
  private readonly http = inject(HttpClient);

  getSettings(): Observable<BusinessSettingsAdmin> {
    return this.http.get<BusinessSettingsAdmin>(`${API_BASE_URL}/admin/settings`);
  }

  updateSettings(payload: UpdateBusinessSettingsPayload): Observable<BusinessSettingsAdmin> {
    return this.http.put<BusinessSettingsAdmin>(`${API_BASE_URL}/admin/settings`, payload);
  }

  getModules(): Observable<TenantModules> {
    return this.http.get<TenantModules>(`${API_BASE_URL}/admin/modules`);
  }

  updateModules(modules: Record<string, boolean>): Observable<TenantModules> {
    return this.http.put<TenantModules>(`${API_BASE_URL}/admin/modules`, modules);
  }

  sendTestEmail(payload?: { toEmail?: string; mailbox?: 'order' | 'passwordReset' }): Observable<{
    toEmail: string;
    from: string;
    mailbox: string;
  }> {
    return this.http.post<{ toEmail: string; from: string; mailbox: string }>(
      `${API_BASE_URL}/admin/settings/email/test`,
      payload ?? {}
    );
  }

  listStripeWebhooks(): Observable<StripeWebhookEndpointsResponse> {
    return this.http.get<StripeWebhookEndpointsResponse>(
      `${API_BASE_URL}/admin/settings/stripe/webhooks`
    );
  }

  createStripeWebhook(baseUrl: string): Observable<StripeWebhookEndpointsResponse> {
    return this.http.post<StripeWebhookEndpointsResponse>(
      `${API_BASE_URL}/admin/settings/stripe/webhooks`,
      { baseUrl }
    );
  }

  deleteStripeWebhook(endpointId: string): Observable<StripeWebhookEndpointsResponse> {
    return this.http.delete<StripeWebhookEndpointsResponse>(
      `${API_BASE_URL}/admin/settings/stripe/webhooks/${encodeURIComponent(endpointId)}`
    );
  }
}
